<template>
  <div class="asf-admin-dashboard">
    <div class="admin-layout">
      <aside class="sidebar">
        <nav>
          <ul>
            <li><router-link :to="{ name: 'ASFAdminBlog' }">Gestión de Blog</router-link></li>
            <li><router-link :to="{ name: 'ASFAdminImages' }">Gestión de imágenes</router-link></li>
            <li v-if="isAdmin"><router-link :to="{ name: 'ASFAdminUsers' }">Gestión de Usuarios</router-link></li>
            <li><a href="#" @click.prevent="logout">Cerrar sesión</a></li>
          </ul>
        </nav>
      </aside>
      <main class="content">
        <!-- Aquí se renderizarán los componentes de gestión -->
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const isAdmin = ref(false); // Estado para controlar la visibilidad del enlace de gestión de usuarios

onMounted(() => {
  // Verificar el rol del usuario al cargar el componente
  const userRole = localStorage.getItem('user_role');
  isAdmin.value = userRole === 'admin';

  // Redirigir a la ruta por defecto si se accede directamente a /ASFadmin/dashboard
  // Esto ya lo maneja el beforeEach en index.js, pero se mantiene por si acaso.
  if (router.currentRoute.value.name === 'ASFAdminDashboard') {
    router.replace({ name: 'ASFAdminBlog' });
  }
});

function logout() {
  localStorage.removeItem('jwt_token'); // Eliminar el token JWT
  localStorage.removeItem('user_role'); // Eliminar el rol del usuario
  localStorage.removeItem('user_name'); // Eliminar el nombre del usuario
  localStorage.removeItem('user_email'); // Eliminar el email del usuario
  router.push({ name: 'ASFAdminLogin' }); // Redirigir a la página de login
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 250px;
  background-color: #f8f9fa;
  padding: 20px;
  border-right: 1px solid #dee2e6;
}

.sidebar nav ul {
  list-style: none;
  padding: 0;
}

.sidebar nav ul li {
  margin-bottom: 10px;
}

.sidebar nav ul li a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
}

.sidebar nav ul li a:hover {
  text-decoration: underline;
}

.content {
  flex-grow: 1;
  padding: 20px;
}
</style>